<div class="header__logo hidden-sm-down">
  <h1><a href="index.html">Material Admin 2.0</a></h1>
</div>